import { render, staticRenderFns } from "./FormContinent.vue?vue&type=template&id=5ab40445&scoped=true&"
import script from "./FormContinent.vue?vue&type=script&lang=js&"
export * from "./FormContinent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab40445",
  null
  
)

export default component.exports